import { createTheme } from "@mui/material/styles";

import colors from "../_colors.scss";
import { adjustColors, colorSuggestions } from "../utils/index.js";

// Agriculture color palette for charts (20 colors)
const agriColors = Array.from({ length: 20 }, (_, i) => colors[`ag${i + 1}`]);

// Choropleth color scales
const choroplethScales = {
	default: [
		colors.choropleth1,
		colors.choropleth2,
		colors.choropleth3,
		colors.choropleth4,
		colors.choropleth5,
	],
	drought: [
		colors.droughtChoropleth1,
		colors.droughtChoropleth2,
		colors.droughtChoropleth3,
		colors.droughtChoropleth4,
		colors.droughtChoropleth5,
	],
	precipitation: [
		colors.precipChoropleth1,
		colors.precipChoropleth2,
		colors.precipChoropleth3,
		colors.precipChoropleth4,
		colors.precipChoropleth5,
	],
	heatwave: [
		colors.heatChoropleth1,
		colors.heatChoropleth2,
		colors.heatChoropleth3,
		colors.heatChoropleth4,
		colors.heatChoropleth5,
	],
	coldwave: [
		colors.coldChoropleth1,
		colors.coldChoropleth2,
		colors.coldChoropleth3,
		colors.coldChoropleth4,
		colors.coldChoropleth5,
	],
	wind: [
		colors.windChoropleth1,
		colors.windChoropleth2,
		colors.windChoropleth3,
		colors.windChoropleth4,
		colors.windChoropleth5,
	],
};

// Social LCA category colors
const socialCategoryColors = [
	colors.socialCat1,
	colors.socialCat2,
	colors.socialCat3,
	colors.socialCat4,
	colors.socialCat5,
];

// MAGNET SSP scenario colors
const scenarioColors = {
	SSP1: colors.scenarioSSP1,
	SSP2: colors.scenarioSSP2,
	SSP3: colors.scenarioSSP3,
};

// Risk level colors
const riskLevelColors = {
	veryLow: colors.riskVeryLow,
	low: colors.riskLow,
	medium: colors.riskMedium,
	high: colors.riskHigh,
	veryHigh: colors.riskVeryHigh,
};

// Opportunity level colors
const opportunityLevelColors = {
	none: colors.opportunityNo,
	low: colors.opportunityLow,
	medium: colors.opportunityMedium,
	high: colors.opportunityHigh,
};

// Pie chart palette
const pieColors = Array.from({ length: 10 }, (_, i) => colors[`pie${i + 1}`]);

const theme = createTheme({
	palette: {
		primary: { main: colors.primary },
		secondary: { main: colors.secondary || colorSuggestions.secondary },
		third: { main: colors.third || colorSuggestions.third },

		primaryLight: { main: adjustColors(colors.primary, 100) },
		primaryDark: { main: adjustColors(colors.primary, -80) },
		secondaryLight: { main: adjustColors(colors.secondary || colorSuggestions.secondary, 100) },
		secondaryDark: { main: adjustColors(colors.secondary || colorSuggestions.secondary, -80) },
		thirdLight: { main: adjustColors(colors.third || colorSuggestions.third, 100) },
		thirdDark: { main: adjustColors(colors.third || colorSuggestions.third, -80) },

		success: { main: colors.success },
		error: { main: colors.error },
		warning: { main: colors.warning },
		info: { main: colors.info },

		dark: { main: colors.dark },
		light: { main: colors.light },
		grey: { main: colors.grey },
		greyDark: { main: colors.greyDark },
		green: { main: colors.green },
		white: { main: "#ffffff" },
	},
	// Extended color palettes for charts and visualizations
	chartColors: {
		agriColors,
		agriColorKeys: Array.from({ length: 20 }, (_, i) => `ag${i + 1}`),
		choroplethScales,
		socialCategoryColors,
		scenarioColors,
		riskLevelColors,
		opportunityLevelColors,
		pieColors,
	},
});

export { agriColors, choroplethScales, socialCategoryColors, scenarioColors, riskLevelColors, opportunityLevelColors, pieColors };

export default theme;
